// English and Swahili texts for the 12 cases. Danish lives in cases.js.
export const caseTexts = {
  en: {
    "fastfood": {
      category: "Fast food",
      description: "A punchy ordering site with menu, prices and pickup — built to take hungry customers from click to burger in seconds.",
    },
    "toejbutik": {
      category: "Clothing store",
      description: "A minimalist fashion universe with collections, lookbook vibes and a shopping experience that feels like a physical atelier.",
    },
    "hygge-tavern": {
      category: "Cozy tavern",
      description: "Warm atmosphere, candlelight and table booking — a site that smells of wood, draft beer and good stories right on the screen.",
    },
    "laege-support": {
      category: "Doctor support",
      description: "Calm, trustworthy and clinically precise — appointment booking and patient information gathered in one safe place.",
    },
    "klart-syn": {
      category: "Window cleaner",
      description: "Crystal-clear windows and online booking — a fresh site that fills the calendar with both private and business customers.",
    },
    "heights-care": {
      category: "Facade service",
      description: "Repair and maintenance at height, presented with trust — certifications and project gallery at the center.",
    },
    "super-vvs": {
      category: "Plumbing",
      description: "Emergency help around the clock — the on-call phone in focus, clear prices and booking in under a minute.",
    },
    "handyman-jan": {
      category: "Handyman",
      description: "One man for every small task — a down-to-earth site with a services list, before/after examples and quick contact.",
    },
    "multi-clean": {
      category: "Cleaning",
      description: "Commercial cleaning with tailored agreements — a calm, professional site that sells trust to businesses.",
    },
    "craftpaint-studio": {
      category: "Painter",
      description: "Color advice and craftsmanship in focus — a visual universe showing finish, color charts and references.",
    },
    "hansen-menswear": {
      category: "Menswear",
      description: "Classic menswear with a modern webshop — sharp product photos and an elegant, masculine mood.",
    },
    "golden-bites": {
      category: "Bakery",
      description: "Sourdough and sweet treats with online ordering — a warm site that almost smells of fresh baking.",
    },
    "craftwork-jan": {
      category: "Craftsmanship",
      description: "Craftsmanship with pride — projects, references and quick contact gathered on one down-to-earth site.",
    },
    "kede-rooms": {
      category: "KEDE Health Platform",
      description: "Calm, bright rooms for recovery — booking and information about KEDE's stay rooms gathered in one place.",
    },
    "kede-water": {
      category: "KEDE Health Platform",
      description: "Clean water as part of health — product info and ordering of KEDE's water solution.",
    },
    "kede-cleaning": {
      category: "KEDE Health Platform",
      description: "Professional cleaning with health in mind — KEDE's cleaning concept presented clearly and simply.",
    },
    "kede-clothes": {
      category: "KEDE Health Platform",
      description: "Functional clothing for health and everyday life — KEDE's clothing line presented with a webshop.",
    },
    "kede-juice": {
      category: "KEDE Health Platform",
      description: "Fresh-pressed juice with a focus on content and quality — KEDE's juice universe with online ordering.",
    },
    "kede-mobile-juice": {
      category: "KEDE Health Platform",
      description: "Juice on wheels — KEDE's mobile juice bar for events and markets, with booking and menu.",
    },
    "kede-internet": {
      category: "KEDE Health Platform",
      description: "Stable internet access as part of the health platform — KEDE's internet solution explained simply.",
    },
  },
  sw: {
    "fastfood": {
      category: "Chakula cha haraka",
      description: "Tovuti ya kuagizia yenye menyu, bei na kuchukua chakula — imejengwa kupeleka wateja wenye njaa kutoka kubofya hadi burger kwa sekunde chache.",
    },
    "toejbutik": {
      category: "Duka la nguo",
      description: "Ulimwengu wa mtindo wa kisasa wenye makusanyo, hisia za lookbook na uzoefu wa ununuzi unaohisi kama atelier ya kweli.",
    },
    "hygge-tavern": {
      category: "Baa ya starehe",
      description: "Mazingira ya joto, mwanga wa mishumaa na kuweka meza — tovuti inayonukia mbao, bia na hadithi nzuri moja kwa moja kwenye skrini.",
    },
    "laege-support": {
      category: "Msaada wa daktari",
      description: "Tulivu, ya kuaminika na sahihi kikliniki — kuweka miadi na taarifa za wagonjwa pamoja mahali salama.",
    },
    "klart-syn": {
      category: "Msafishaji wa madirisha",
      description: "Madirisha safi kabisa na kuweka nafasi mtandaoni — tovuti mpya inayojaza kalenda na wateja wa kibinafsi na wa biashara.",
    },
    "heights-care": {
      category: "Kazi za juu",
      description: "Ukarabati na matunzo juu ya mabina, yaliyowasilishwa kwa uaminifu — vyeti na matunzio ya miradi katikati.",
    },
    "super-vvs": {
      category: "Fundi maji",
      description: "Msaada wa dharura saa nzima — simu ya wito mbele, bei wazi na kuweka nafasi kwa chini ya dakika moja.",
    },
    "handyman-jan": {
      category: "Fundi wa kila kitu",
      description: "Mtu mmoja kwa kila kazi ndogo — tovuti ya kawaida yenye orodha ya huduma, mifano ya kabla/baada na mawasiliano ya haraka.",
    },
    "multi-clean": {
      category: "Usafi",
      description: "Usafi wa biashara kwa mikataba maalum — tovuti tulivu na ya kitaalamu inayouza uaminifu kwa makampuni.",
    },
    "craftpaint-studio": {
      category: "Fundi wa rangi",
      description: "Ushauri wa rangi na ufundi mbele — ulimwengu wa kuona unaonyesha umalizi, chati za rangi na kumbukumbu.",
    },
    "hansen-menswear": {
      category: "Mavazi ya wanaume",
      description: "Mavazi ya kiume ya kiasili yenye duka la mtandaoni la kisasa — picha kali za bidhaa na hali ya kifahari ya kiume.",
    },
    "golden-bites": {
      category: "Duka la mikate",
      description: "Mkate wa chachu na vitu vitamu kwa kuagiza mtandaoni — tovuti ya joto inayonukia karibu kama mikate mipy.",
    },
    "craftwork-jan": {
      category: "Ufundi stadi",
      description: "Ufundi wa kujivunia — miradi, kumbukumbu na mawasiliano ya haraka pamoja kwenye tovuti ya kawaida.",
    },
    "kede-rooms": {
      category: "KEDE Health Platform",
      description: "Vyumba tulivu na venye mwanga vya kupumzika — kuweka nafasi na taarifa kuhusu vyumba vya KEDE pamoja mahali pamoja.",
    },
    "kede-water": {
      category: "KEDE Health Platform",
      description: "Maji safi kama sehemu ya afya — taarifa za bidhaa na kuagiza suluhu la maji la KEDE.",
    },
    "kede-cleaning": {
      category: "KEDE Health Platform",
      description: "Usafi wa kitaalamu kwa kuzingatia afya — dhana ya usafi ya KEDE imewasilishwa wazi na kwa urahisi.",
    },
    "kede-clothes": {
      category: "KEDE Health Platform",
      description: "Mavazi ya kufaa kwa afya na maisha ya kila siku — laini ya mavazi ya KEDE yenye duka la mtandaoni.",
    },
    "kede-juice": {
      category: "KEDE Health Platform",
      description: "Jusi mpya iliyokamuliwa yenye lengo la yaliyomo na ubora — ulimwengu wa jusi wa KEDE wenye kuagiza mtandaoni.",
    },
    "kede-mobile-juice": {
      category: "KEDE Health Platform",
      description: "Jusi kwenye magurudumu — baa ya jusi ya kubebeka ya KEDE kwa matukio na masoko, yenye kuweka nafasi na menyu.",
    },
    "kede-internet": {
      category: "KEDE Health Platform",
      description: "Mtandao imara wa intaneti kama sehemu ya jukwaa la afya — suluhu la intaneti la KEDE limeelezwa kwa urahisi.",
    },
  },
};
